<div class="logout_container" #divWithDir>
    <h1>{{'login.logoutMsg' | translate}} {{name}}!</h1>
    <button mat-raised-button color="primary" (click)="close()" cdkFocusInitial>{{'login.logoutCloseBtn' | translate}}</button>
</div>